import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/SiteAuditIndex'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'Site Audit Index'}
        >
            <Component 
            />
        </Layout>
    )
}

export default BlockInspectionStatusMasterlist